export default "__VITE_ASSET__4bc35eb8__"